export const CATALOG_ACTIONS = '/catalog/actions';
